import React from "react";

function MilesPointsReferralLogTable() {
  return (
    <div className="w-full flex flex-col gap-2">
      {/* Header */}
      <div className="w-full p-4 flex items-center bg-[#F0F6FC] gap-2">
        <div className="w-44 ">
          <small>DATE</small>
        </div>
        <div className="flex flex-1 ">
          <small>NAME</small>
        </div>
        <div className="w-44 ">
          <small>STATUS</small>
        </div>
        <div className="w-44 ">
          <small>POINT</small>
        </div>
      </div>
      {[...Array(10)].map((_, index) => (
        <div
          className="w-full p-4 flex items-center bg-white gap-2"
          key={index}
        >
          <div className="w-44 flex flex-col">
            <small>
              12:54<small className="text-primary1">pm</small>{" "}
            </small>
            <small>22/03/2023</small>
          </div>
          <div className="flex flex-1 ">
            <small>Fly Dey Go Travels & Tours</small>
          </div>
          <div className="w-44 ">
            <Status status="booked" />
          </div>
          <div className="w-44 ">
            <small>50</small>
          </div>
        </div>
      ))}
    </div>
  );
}

const Status = ({ status }) => {
  const statusStyle = () => {
    switch (status) {
      case "booked":
        return "bg-[#009688]/10 text-[#009688]";
      case "registered":
        return "bg-[#1E61DC]/10 text-[#1E61DC]";
      default:
        return "bg-[#1E61DC]/10 text-[#1E61DC]";
    }
  };
  return (
    <div
      className={`text-sm px-2 py-[6px] w-fit rounded-md font-semibold ${statusStyle()}`}
    >
      {status}
    </div>
  );
};

export default MilesPointsReferralLogTable;
